import { ProtocolState } from '@modules/protocol/interfaces/protocol';
import { createAction, props } from '@ngrx/store';

export const setProtocolState = createAction('[Protocol] Set', props<{ protocol: ProtocolState }>());
export const updateProtocolState = createAction('[Protocol] Update', props<{ protocol: ProtocolState }>());
